import fetchAvailablePackages from './fetch-available-packages';

export default {
  fetchAvailablePackages,
};
